const ls = {
    get(key) {
        let data = localStorage.getItem(key);

        if (data) {
            data = JSON.parse(data);
        }

        return data || {};
    },

    set(key, data) {
        let dataStr = JSON.stringify(data);

        localStorage.setItem(key, dataStr);
    }
};

export default ls;
